import { useStateContext } from "../../Contexts/ContextProvider";

const SuperAdminPortal = () => {
  const { API } = useStateContext();

  return (
    <main className="min-vh-100 d-flex align-items-center justify-content-center p-4">
      <section className="text-center">
        <h1 className="h4">Super-admin console</h1>
        <p className="text-secondary">Super-admin access is managed separately from tenant workspaces.</p>
        <a className="btn btn-dark" href={`${API}/super_admin/login`}>
          Open super-admin sign in
        </a>
      </section>
    </main>
  );
};

export default SuperAdminPortal;